import { CardHeader, Icon, Modal, Button } from '../../../../components'
import { ThermostatAdjustment } from '../../../../types/thermostatAdjustment'
import useLastAdjustmentCardHeaderViewModel from './useLastAdjustmentCardHeaderViewModel'
import { getAdjustmentType, type AdjustmentType } from '../utils'
import { useNavigation } from '@/app/hooks'

interface LastAdjustmentCardHeaderProps {
  adjustment: ThermostatAdjustment | undefined | null
  thermostatId: number
}

export { getAdjustmentType, type AdjustmentType }

export default function LastAdjustmentCardHeader({
  adjustment,
  thermostatId,
}: LastAdjustmentCardHeaderProps) {
  const viewModel = useLastAdjustmentCardHeaderViewModel({
    adjustment,
    thermostatId,
  })
  const navigate = useNavigation()

  if (!viewModel.shouldShow) {
    return null
  }

  const handleAdjustSettings = () => {
    if (viewModel.modalContent?.adjustSettingsUrl) {
      navigate.push(viewModel.modalContent.adjustSettingsUrl)
      viewModel.handleCloseModal()
    }
  }

  return (
    <>
      <CardHeader
        icon={<Icon name="Leaf" />}
        title={viewModel.title}
        subtitle={viewModel.subtitle}
        color="green"
        flat={false}
        onAction={viewModel.handleOpenModal}
        actionIcon={<Icon name="Info" />}
      />

      <Modal
        id="last-adjustment-info-modal"
        open={viewModel.isModalOpen}
        onClose={viewModel.handleCloseModal}
        maxWidth="400px"
      >
        <div className="flex flex-col gap-5 items-center">
          <div className="text-center">
            <div className="inline-flex items-center justify-center bg-green-100 rounded-[10px] w-16 h-16">
              <Icon name="Leaf" size={32} className="text-themed-green-700" />
            </div>
          </div>

          <div className="text-center font-bold text-base text-themed-neutral leading-normal">
            {viewModel.modalContent?.title}
          </div>

          <div className="bg-white border border-themed-green-700 border-solid rounded-[10px] p-4 w-full">
            <div className="flex flex-col">
              <div className="font-bold text-sm text-themed-green-700 leading-5 mb-2">
                Reasons for this adjustment:
              </div>
              <div className="space-y-2">
                {viewModel.modalContent?.reasons.map((line, index) => (
                  <div key={index} className="flex gap-2 items-start">
                    <Icon
                      name="JustCheck"
                      size={16}
                      color="green"
                      className="shrink-0 mt-1"
                    />
                    <span className="font-medium text-sm text-[#5d5d5d] leading-5">
                      {line.map((part, pIdx) => (
                        <span
                          key={pIdx}
                          className={part.bold ? 'font-bold' : undefined}
                        >
                          {part.text}
                        </span>
                      ))}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-4 w-full">
            <Button
              id="adjust-settings-button"
              variant="primary-subtle"
              onClick={handleAdjustSettings}
            >
              Adjust Settings
            </Button>

            <Button
              id="close-modal-button"
              variant="primary"
              onClick={viewModel.handleCloseModal}
            >
              Close
            </Button>
          </div>
        </div>
      </Modal>
    </>
  )
}
